var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'avatar',
        'avatar-' + _vm.size,
        'bg-' + _vm.userColor,
        _vm.onDuty ? 'on-duty' : '',
        !_vm.userId || !_vm.ring ? 'no-ring' : '' ]},[(_vm.src && _vm.validSrc)?_c('img',{staticClass:"avatar-image",attrs:{"src":_vm.src},on:{"error":function($event){_vm.validSrc = false}}}):(_vm.icon)?_c('div',{staticClass:"avatar-icon"},[_c('q-icon',{attrs:{"icon":_vm.icon}})],1):_c('div',{class:[
            'avatar-text',
            { 'text-inkwell-0' : _vm.userColor === 'gray-10' }
        ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }